export const COUNTRY_VALIDATION_FIELDS = ['ke']
export const CITY_STATE_VALIDATION_FIELDS = ['ln']
